export default __webpack_public_path__ + "static/ninja-logo-0ec8953dd8f7bb1559aaf17b25a2a489.png";